<template>
    
    <v-dialog scrollable overlay-color="#000000FF" persistent v-model="dialog_com" 
        :fullscreen="$vuetify.display.mobile ? true : false" 
        :width="$vuetify.display.mobile ? '100%' : '800px'"
        class="none_radius">
        
        <v-card>

            <v-card-title>
                <v-row justify="space-between">
                    <v-col cols="6" md="3">
                    <span class="dialog_title">컨텐츠 선택</span>
                  </v-col>
                  <v-spacer/>
                </v-row>
            </v-card-title>

            <v-card-text class="ma-0 pl-5 pr-5 pt-3">
                <v-container>

                    <v-row align="start" justify="center" dense v-if="itemList_com.length > 0">
                        <v-col cols="12" align="center">
                          <div class="d-flex flex-wrap justify-center">
                            <div v-for="item in itemList_com" :key="item" class="ma-1 content-item-wrapper"
                                 :class="{ 'selected': select_com == item }"
                                 @click="select_item(item)">
                              <template v-if="item != null && item != undefined">
                                <!--
                              <ThumScreen
                                :screen_model="item.screen_model"
                                :scalewidth="200"
                                :style="select_com == item ? 'border: 1px solid red' : 'border: 1px solid gray'"
                                @click="select_item(item)"
                                />
                                -->
                                <v-img
                                  width="200"
                                  :src="item.MCON_IMG"
                                  :lazy-src="item.MCON_IMG"
                                  aspect-ratio="1"
                                  />
                                <div class="content-item-name">{{ item.MCON_NAME }}</div>
                                </template>
                            </div>
                          </div>
                        </v-col>

                    </v-row>

                    <!-- 하단검색 -->
                    <searchbar ref="searchbar_com" @searchcallback="search_run_com"/>
                    
                    <!-- 하단페이징영역 -->
                    <pagingbar ref="paging_com" :page="page_com" @loadpage="movepage_com"/>  

                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-row justify="center">
                    <v-col align="center" cols="12" md="10">
                        <v-btn class="mr-5" @click="close_com">닫기</v-btn>
                        <v-btn class="mr-5" @click="clear_com">선택취소</v-btn>
                        <v-btn class=""  @click="save_com">선택</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
  
        </v-card>
    
    </v-dialog>

  </template>
  
  <script>
  import { useContentStore } from "@/stores/content";
  import { ref } from '@vue/reactivity';
  import Screen_Model from '@/nextts/model/Screen_Model';
  import ThumScreen from '@/nextvue/preview/ThumScreen.vue';
  
  export default {
  
      components:{
        ThumScreen,
      },
  
      watch:{

      },

      data: () => ({
        
        dialog_com: false,

        //필수 페이징 파라메터
        page_com : 1,
  
        itemList_com: [],
        select_com:{},
        
        SEARCH_LOCALID_COM:null,   

        sort_name_com: 'UP_DATE',
        sort_type_com: true,    //true : DESC, false: ASC (UP_DATE 기준 최신순)
        search_keyword_com : '',
  
        //한 페이지 ROW 개수 설정
        pagerow_com : 20,       //한 페이지에 보여줄 row수
  
      }),
  
      setup(){
          var paging_com      = ref(null);
          var searchbar_com   = ref(null);
          let contentStore    = useContentStore();
          return {paging_com, searchbar_com, contentStore};
      },


      methods: {

        //다이얼로그 닫기
        close_com () {
            this.dialog_com = false
            this.select_com = [];
        },
        
        //선택 초기화
        clear_com () {
            this.$emit('callback', null);
            this.dialog_com = false
            this.select_com = [];
        },        
        
        //추가 저장
        save_com(){
          if(this.select_com.MCON_IDX != null && this.select_com.MCON_IDX != undefined){
            this.$emit('callback', {idx:this.select_com.MCON_IDX, name:this.select_com.MCON_NAME, img:this.select_com.MCON_IMG});
            //콜백 호출 후 닫아야함.
            this.dialog_com = false
            this.select_com = [];
          }else{
            this.$swal('컨텐츠를 선택하세요');
            return;
          }
        },  

        select_item(item){
            this.select_com = item;
        },

        loadcontent(aidx){

            //console.log("aidx : " + aidx);
            this.SEARCH_LOCALID_COM = aidx;
            
            this.dialog_com = true;
            this.loadpage_com(1);

        },

        //검색
        search_run_com(searchkeyword){
          if(searchkeyword != null && searchkeyword != undefined && searchkeyword.length > 0){
            this.search_keyword_com = searchkeyword;
          }else{
            this.search_keyword_com = '';
          }
          this.loadpage_com(1);
        },      
          
        movepage_com(p){
          this.loadpage_com(p);
        },

        customsort_com(sortname){
          this.sort_name_com = sortname;
          this.sort_type_com = !this.sort_type_com;
          this.loadpage_com(this.page_com);
        },
  
        async loadpage_com(p){
            //토큰값 체크
            let token;
            try{
            token = await this.$fireauth.currentUser.getIdToken();
            }catch(error){
            token = this.$userStore.fireToken;
            }

            this.page_com = p;
            //this.paging_com.setpage(this.page_com);

            this.$http.post(this.$api_home+'/MyContentList',{
                search_keyword: this.search_keyword_com == null || this.search_keyword_com == undefined ?  '' : this.search_keyword_com
              , sort_name:this.sort_name_com
              , sort_type: this.sort_type_com == true ? "DESC" : "ASC" 
              , page: this.page_com
              , pagerow: this.pagerow_com
              , LOCALID:this.SEARCH_LOCALID_COM
            },{headers: { firetoken:token}})
            .then((result)=>{
              
              if(result.data.resultCode == 0){
                  this.paging_com.setpage(this.page_com);
                  this.paging_com.makepaging(result.data.totalcnt, this.pagerow_com);
                  const list = result.data.resultData;
                  this.itemList_com.splice(0, this.itemList_com.length);   //데이터 초기화
                  list.forEach(element => {
                    //let screen_model        = new Screen_Model();
                    //screen_model.setStringValue(element.THUM_JSON);
                    //screen_model.cacheFont();
                    //element.screen_model = screen_model;
                    if(element.MCON_STATE == 1){
                      this.itemList_com.push(element); 
                    }
                  });
                  this.$forceUpdate();
                }else if(result.data.resultCode == 2){
                //로그인 필요
                this.$swal("토큰 만료로 인해 다시 로그인해주세요.");
                this.$emitter.emit('clearsession');
              }
            })
            // eslint-disable-next-line no-unused-vars
            .catch((error)=>{
              this.loading = false;
              if(error.message == 'Request failed with status code 429')
              {
                this.$swal('많은 요청으로 인해 잠시 후 시도해주세요.');
              }else{
                this.$swal(error.message);
              }
            });
  
        },


      },
    
  }
  </script>
  
  <!-- scoped가 있으면 해당 컴포넌트에서만 스타일이 반영됨 -->
  <style scoped>
  
  .content-item-wrapper {
    transition: all 0.2s ease;
    cursor: pointer;
    border-radius: 8px;
    padding: 8px;
    border: 2px solid transparent;
    box-sizing: border-box;
    background: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .content-item-wrapper:hover {
    background-color: rgba(110, 0, 250, 0.05);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .content-item-wrapper.selected {
    border-color: #2196F3;
    border-width: 3px;
    background-color: rgba(33, 150, 243, 0.15);
    box-shadow: 0 4px 16px rgba(33, 150, 243, 0.4);
    transform: scale(1.02);
  }

  .content-item-name {
    margin-top: 6px;
    text-align: center;
    font-size: 13px;
    color: #333;
    width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  </style>